<template>
  <div id="login">
    <div class="ipt_area">
      <div class="img_p">
        <img src="../../assets/images/3x/phone.png" alt=""><span style="padding-left: 0.2rem">{{qh_code}}</span>
      </div>
      <van-field label="" v-model="tel" class="form_border"/>
    </div>
    <div class="ipt_area ipt_area2">
      <div class="img_p">
        <img src="../../assets/images/3x/code.png" alt="">
      </div>
      <van-field label="" value="" v-model="code" class="form_border"/>
      <div class="code_btn" @click.prevent="comfirmSms" :disabled="unavailable" ref="sendCodeBtn">{{buttonText}}</div>
    </div>
    <van-button type="default" block @click="register">{{$t('message.zc')}}</van-button>
    <van-dialog v-model="show" confirm-button-text="Xác nhận gửi đi" :confirm-button-color="glo_color" @confirm="sendCode">
      <div>
        <div class="smsimg"></div>
        <div style="padding: 15px 25px;min-height: 150px">
          <div style="text-align: center;margin-bottom: 30px">Vui lòng chọn cách nhận mã xác thực</div>
          <van-radio-group v-model="radio">
            <van-cell-group>
              <van-cell :title="item.title" clickable  v-for="(item,index) in smsType" :key="index" @click="radio = item.type">
                <template #right-icon>
                  <van-radio :name="item.type" :checked-color="glo_color"/>
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>

  import {login, sendCode, postRenInfo,newSendOtpType} from '../../ports/port'
  let timer;
  export default {
    name: "forget",
    data() {
      return {
        tel: '',//账号
        code: '',//密码
        unavailable: false,
        buttonText: this.$t('message.send_code'),
        show_error_tel: false,
        error_tel: '',
        show_error_psd: false,
        error_psd: '',
        qh_code: this.$qh,
        sj_has_ipt: false,
        glo_color:this.$color,
        voiceText:this.$t('message.voice_code'),
        send_meth:'voice',
        lat:'',
        lng:'',
        resg_type:'3',//6：h5安卓，7：h5苹果; 3:其他
        show:false,
        radio:0,
        smsType:[]
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position)=>{
          this.lng = position.coords.longitude;
          this.lat = position.coords.latitude;
        }, function () {});
      }
      /*判断当前环境是Android还是iOS*/
      var u = navigator.userAgent;
      // 安卓
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      // IOS
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if(isAndroid){
        this.resg_type = "6";
      }else if(isiOS){
        this.resg_type = "7";
      }else{
        this.resg_type = "3";
      }
    },
    methods: {
      comfirmSms(){
        //平台、设备和操作系统
        var system = {
          win: false,
          mac: false,
          xll: false
        };
        //检测平台
        var p = navigator.platform;
        system.win = p.indexOf("Win") == 0;
        system.mac = p.indexOf("Mac") == 0;
        system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);

        if (system.win || system.mac || system.xll) {
          this.$notify({
            type: 'danger',
            message: this.$t('message.use_phone')//请使用手机登录
          });
        }else{
          if(this.tel.trim() == ""){
            this.$notify({
              type: 'danger',
              message: this.$t('message.enterPhone')//请使用手机登录
            });
            return false
          }
          this.$store.commit('edit', true);
          newSendOtpType({phone: this.tel})
            .then(res=>{
              if(res.data.code==200){
                this.smsType = res.data.data;
                res.data.data.map(e=>{
                  if(e.type==3){
                    e.title = "Zalo";
                  }else if(e.type==2){
                    e.title = "Cuộc gọi";
                  }else{
                    e.title = "Tin nhắn";
                  }
                });
                const fil = res.data.data.filter(e=>{
                  return e.if_default == 1
                });
                this.radio = fil[0].type;
                this.show = true;
              }else{
                this.$notify({
                  type: 'danger',
                  message: res.data.msg
                });
              }
              this.$store.commit('edit', false);
            });
        }
      },
      sendCode() {
        this.leave_tel();
        if (!this.unavailable && this.sj_has_ipt) {
          this.unavailable = true;
          let i = 61;
          timer = setInterval(() => {
            i--;
            this.buttonText = i + 'S';
            if (i < 1) {
              clearInterval(timer);
              this.buttonText = this.$t('message.send_code');
              this.unavailable = false;
              this.$refs.sendCodeBtn.style.backgroundColor = this.glo_color;
            }
          }, 1000);
          this.$refs.sendCodeBtn.style.backgroundColor = '#adebeb';

          let ids = sessionStorage.getItem('chntoken');
          if (ids == 'undefined' || ids == 'null') {
            ids = this.$route.query.chntoken;
          }
          //发送验证码
          let data = {phone: this.tel, type: 2, ctype: 1,genre:this.radio,chntoken:ids,sourse:this.sourse,allRoute:this.$route.fullPath};//sourse  1：全流程，3：半流程
          sendCode(data)
            .then(res => {
              if (res.data.code == 200) {
                if((!Array.isArray(res.data.data)) && res.data.data.type==3){
                  this.$notify({type: 'success', message: "Vui lòng mở Zalo kiểm tra mã xác thực"});//请打开zalo查收验证码
                }else{
                  this.$notify({type: 'success', message: this.$t('message.ver_code_success')});
                }
              }else if (res.data.code == 202) {
                this.$notify({type: 'danger', message: this.$t('message.ver_code_error')});
              }else if (res.data.code == 203) {
                this.$notify({type: 'danger', message: res.data.msg});
              }
            })
            .catch(err => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (err.toString().indexOf('timeout') != -1) {
                this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
              }
            })
        }
      },
      sendMethod(){
        if(this.send_meth=='voice'){
          this.send_meth='otp';
          this.voiceText = this.$t('message.otp_message');
        }else{
          this.send_meth='voice';
          this.voiceText = this.$t('message.voice_code');
        }
        clearInterval(timer);
        this.buttonText = this.$t('message.send_code');
        this.unavailable = false;
        this.$refs.sendCodeBtn.style.backgroundColor = this.glo_color;
      },
      leave_pas() {
        this.code = this.code.replace(/\s+/g, "");
        if (this.code == "" || this.code == null || this.code == undefined) {
          this.error_psd = this.$t('message.th_yys_qsryzm');//请输入验证码
          this.show_error_psd = true;
        } else {
          this.show_error_psd = false;
        }
      },

      /***验证手机号***
       *
       * 越南手机，泰国手机号长度一样
       * 电话前面有0就10位，没有就9位
       *
       */
      leave_tel() {
        this.tel = this.tel.replace(/\s+/g, "");
        if (this.tel == "" || this.tel == null || this.tel == undefined) {
          this.$toast({
            message: this.$t('message.enterPhone')
          });
        } else {

          if (!(/^\d{8}$|^\d{9}$/.test(this.tel.substring(1)))) {//去除84前的‘+’，然后算9位电话是否有0，有就10位，没有就9，然后在加84
            this.$toast({
              message: this.$t('message.verity_iphone')
            });
          } else {
            this.sj_has_ipt = true;
          }
        }
      },
      register() {
        if(this.code.trim().length<4 || this.code.trim().length>6){
          this.$notify({
            type: 'danger',
            message: this.$t('message.yys_error_code')//请使用手机登录
          });
          return false
        }
        this.$store.commit('edit', true);//打开全局的loading
        this.leave_tel();
        this.leave_pas();
        //注册后，存储登录时间，控制登录后首页的信息窗口的展示时间，控制展示3分钟
        localStorage.setItem('broadcast',Date.now()+180000);
        //平台、设备和操作系统
        var system = {
          win: false,
          mac: false,
          xll: false
        };
        //检测平台
        var p = navigator.platform;
        system.win = p.indexOf("Win") == 0;
        system.mac = p.indexOf("Mac") == 0;
        system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
        if (system.win || system.mac || system.xll) {
          this.$notify({
            type: 'danger',
            message: this.$t('message.use_phone')//请使用手机登录
          });
        } else {
          // let ids = this.$route.query.chntoken; //获取网址后面的chntoken
          let ids = sessionStorage.getItem('chntoken');
          let chntokenOther = sessionStorage.getItem('chntokenOther');
          let aff_sid = sessionStorage.getItem('aff_sid');
          let clickid;
          if(chntokenOther!=null){
            clickid = chntokenOther.split('clickid=')[1];
          }else{
            clickid='';
          }
          if (ids == 'undefined' || ids == 'null') {
            ids = '';
          }
          if(aff_sid == 'undefined' || aff_sid == 'null'){
            aff_sid = '';
          }
          let data = {
            phone: this.tel,
            code: this.code,
            d_id: '',
            login_type: '6',
            appName: 'Vay Som',
            lang: 'vt-se',
            chntoken: ids,
            chntokenOther:chntokenOther,
            clickid:clickid,
            aff_sid:aff_sid,
            lat:this.lat,
            lng:this.lng,
            resg_type:this.resg_type
          };
          if (this.tel == "") {
            this.$notify({type: 'danger', message: this.$t('message.enterPhone')});
            this.$store.commit('edit', false);
          } else if (this.code == "") {
            this.$notify({type: 'danger', message: this.$t('message.message_ipt_code')});
            this.$store.commit('edit', false);
          } else if (this.tel != "" && this.code != "") {
            login(data)
              .then(res => {
                if (res.data.code == 200) {
                  if(res.data.data.hasOwnProperty('reg')){
                    sessionStorage.setItem('hasRegD','reg');
                    if(sessionStorage.getItem('callBackRe')!=null){
                      let str = sessionStorage.getItem('callBackRe');
                      if(str.indexOf("\\'")==-1){
                        eval(str)
                      }else{
                        let n = str.replaceAll("\\'","'");
                        eval(n);
                      }
                    }
                  }
                  let tk = JSON.stringify(res.data.data);
                  localStorage.setItem("tokenAll", tk);//本地保存token
                  this.$notify({
                    type: 'success', message: this.$t('message.login_success'), onClose: () => {
                      this.$store.commit('edit', false);
                      postRenInfo({userid: res.data.data.userid})
                        .then(res=>{
                          let len =0;//必须已经认证的个数
                          let nolen =0;//非必须已经认证的个数
                          let total = 0;//总共显示的个数
                          res.data.data.forEach((item, index) => {
                            //is_true=>1未认证 2已认证   is_display=》1显示 0不显示   is_varify=》1必须认证  0不必须认证
                            if (item.is_true == 2 && item.is_varify == 1 && item.is_display == 1) {//已经认证，并且是显示的且必须认证的
                              len++;
                            }
                            if(item.is_varify == 0 && item.is_display == 1){//判断有多少显示的，但是非必须认证的
                              nolen++;
                            }
                            if(item.is_display == 1){
                              total++;
                            }
                          });
                          if(len==total||(nolen+len)==total){
                            this.$router.replace({path:'/schedule',query:{index:1}});
                          }else{
                            this.$router.replace('/home');
                          }
                        })
                    }
                  });
                } else {
                  this.$notify({type: 'danger', message: this.$t('message.login_error')});
                  this.$store.commit('edit', false);
                }
              })
              .catch(err => {
                this.$store.commit('edit', false);//关闭全局的loading
                if (err.toString().indexOf('timeout') != -1) {
                  this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
                }
              })
          }
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  #login {
    padding: 0.2rem 1.02rem;

    .ipt_area {
      position: relative;

      .img_p {
        position: absolute;
        z-index: 1;
        left: 0.45rem;
        top: 0;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        > img {
          height: 0.53rem;
        }
        span{
          font-size: 0.35rem;
        }
      }
    }

    .ipt_area2 {
      position: relative;

      > img {
        left: 0.41rem;
      }

      .code_btn {
        background: $color;
        width: 3.31rem;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        border-bottom-right-radius: 8px;
        border-top-right-radius: 8px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.35rem;
      }
    }

    .ipt_text {
      margin-top: 0.21rem;
      font-size: 0.08rem;
      text-align: left;
      margin-bottom: 0.61rem;

      span {
        color: $color;
      }
    }
    .form_border{
      border-color: $slide_color;
    }
  }

  /deep/ .van-cell.van-field {
    @include borderSty;
    margin: 0.4rem 0;
  }

  /deep/ .van-cell {
    line-height: 20px !important;
  }

  .van-button--default {
    @include defaultBtn;
  }

  /deep/ .van-field__control {
    padding-left: 1.5rem !important;
  }

  /deep/ .ipt_area2 .van-field__control {
    padding-left: 0.9rem !important;
  }
  /deep/ .van-cell{
    padding: 0.2rem!important;
    font-size: 0.35rem!important;
  }
  .smsimg{
    background: url('../../assets/images/index/smsType.png') no-repeat top left;height: 135px;width: 100%;
    background-size: cover;
  }
  /deep/ .van-cell--clickable{
    padding: 0.6rem 0 0.2rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/register.vue